export enum SHORT_URL_TYPE {
  QUOTE_URL = 1,
  PARTIAL_URL = 0,
}
